import { merge } from 'lodash';
import { APP_SETTINGS_VERSION_2 } from '@wix/wix-vod-constants/app-settings';

/* Don't change settings here! To change settings behavior, create new version */

/* This version includes addition of parameters for compact action bar.
 Using old colors for old users */

export function migrateToV2(appSettingsV1) {
  const {
    colors = {}
  } = appSettingsV1;
  const {
    backgroundColor,
    buttonsAndLinksColor,
    compactMenuBackgroundColor,
    compactMenuActionsColor
  } = colors;
  return merge({}, appSettingsV1, {
    numbers: {
      settingsVersion: APP_SETTINGS_VERSION_2
    },
    colors: {
      compactMenuBackgroundColor: compactMenuBackgroundColor || backgroundColor,
      compactMenuActionsColor: compactMenuActionsColor || buttonsAndLinksColor
    }
  });
}
//# sourceMappingURL=version-2.js.map